<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1-3">
<p class="para">Yes, a killing like this was wilful murder, but someone would have to agree to take on the case, and he would be pitted against a massive groundswell of feeling that such an event was in some way ‘just’ and that honour was a personal matter, seen by many as entirely separate from any concepts in the criminal law. The two men involved were not only officers and therefore gentlemen, but businessmen in Liverpool society and known throughout Lancashire. Most likely, Brookes would have been seen as the least admirable, subject to the petulant and irrational behaviour that had him in its grasp for a long time before this fatal dawn appointment with death.</p>
<p class="para"><span class="t16">If Brookes’ relatives wanted to press charges against Bolton,</span> <span class="t17">they would have had to do what a Mr Garrow applied to do to</span> <span class="t17">conduct a criminal proceeding against a man who had written a</span> <span class="t16">letter trying to provoke a duel, saying:</span></p>
<p class="extractTextNoIndentTB"><span class="t18"><em class="italic">Sir, I have been informed of your unwarrantable conduct in forcing my gate, which you found locked. I suppose you thought it a public road; but that point shall be decided in a court of law. Now, Sir, I have only to add that I consider it a personal insult to myself and expect the satisfaction of a man of honour…</em></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_ch13.vue?656cbeed